import React, { useEffect, useState } from 'react';
import { Image as RNImage } from 'react-native';
import { Box } from '@gluestack-ui/themed';

type AspectImageProps = {
  uri: string;
  alt?: string;
  maxHeight?: number;
};

export const AspectImage: React.FC<AspectImageProps> = ({
  uri,
  alt,
  maxHeight = 260,
}) => {
  const [aspectRatio, setAspectRatio] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    RNImage.getSize(
      uri,
      (width, height) => {
        if (cancelled) return;
        if (!width || !height) return;
        setAspectRatio(width / height);
      },
      () => {
        if (cancelled) return;
        setAspectRatio(null);
      },
    );
    return () => {
      cancelled = true;
    };
  }, [uri]);

  return (
    <Box borderRadius="$md" overflow="hidden" style={{ width: '100%', maxHeight }}>
      <RNImage
        source={{ uri }}
        accessibilityLabel={alt}
        resizeMode="contain"
        style={{
          width: '100%',
          height: aspectRatio ? undefined : maxHeight,
          aspectRatio: aspectRatio ?? undefined,
          maxHeight,
        }}
      />
    </Box>
  );
};

export default AspectImage;
